export let FUNDED = "/funded";
export let PAY = "/pay";
export const DISABLE_WORKER = "/workerActions";
export const LANDING = '/'
export const LOGIN = '/login'
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ALL_JOBS = '/allJobs';
export const OTP = '/otp';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const PASSWORD_CONFIRM = '/pw-confirm';
export const ERROR = '/error';
export const BACKEND_BASE_URL = process.env.NODE_ENV==="development" ? "https://staging-supwork.glitch.me" : "https://supwork-api-xdfei.ondigitalocean.app"
export const ADMIN_LOGIN = "/admin_area"